import { render, staticRenderFns } from "./ques32.vue?vue&type=template&id=3e65a0de&scoped=true"
import script from "./ques32.vue?vue&type=script&lang=js"
export * from "./ques32.vue?vue&type=script&lang=js"
import style0 from "./ques32.vue?vue&type=style&index=0&id=3e65a0de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e65a0de",
  null
  
)

export default component.exports